import { render, staticRenderFns } from "./BayItem.vue?vue&type=template&id=86c41e2a&scoped=true&"
import script from "./BayItem.vue?vue&type=script&lang=js&"
export * from "./BayItem.vue?vue&type=script&lang=js&"
import style0 from "./BayItem.vue?vue&type=style&index=0&id=86c41e2a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c41e2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\web\\V-LAB\\project\\bayes-vue2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86c41e2a')) {
      api.createRecord('86c41e2a', component.options)
    } else {
      api.reload('86c41e2a', component.options)
    }
    module.hot.accept("./BayItem.vue?vue&type=template&id=86c41e2a&scoped=true&", function () {
      api.rerender('86c41e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BayItem/BayItem.vue"
export default component.exports